import styled, { css } from 'styled-components';

export const Container = styled.div`
  position: fixed;
  inset: 0;
  z-index: 999;
  display: flex;
  overflow-x: hidden;
  overflow-y: auto;

  &[aria-hidden='true'] {
    display: none;
  }
`;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background-color: rgb(0 0 0 / 0.55);
  ${(props) =>
    props.$hidden &&
    css`
      background-color: transparent;
    `}
`;

export const ContentInner = styled.div`
  padding: ${(props) => props.$pad}px;
`;

export const Content = styled.div`
  margin: auto;
  border-radius: 4px;
  z-index: 999;
  position: relative;
  background-color: #fff;
  color: #333;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  /* overflow: auto; */
  max-height: 90vh;
  min-width: 380px;
  ${(props) =>
    props.$w &&
    css`
      width: ${props.$w};
    `}
  &.img {
    width: 1248px;
    height: 800px;
    max-height: none;
    max-width: none;
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.95);
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.7);
    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      border-radius: 4px;
      line-height: 1;
      /* padding: 0;
      margin: 0;
      display: block; */
    }
    ${ContentInner} {
      padding: 0;
      width: 100%;
      height: 100%;
    }
  }
  ${(props) =>
    (props.theme === 'dark' || props.theme.theme === 'dark') &&
    css`
      background-color: #333;
      color: #fff;
    `}
`;

export const Title = styled.div`
  padding: ${(props) => props.$pad}px;
  font-size: 20px;
  line-height: 1;
  background: #fafafa;
  font-weight: bold;
  /* text-align: center; */
  border-bottom: 1px solid #ccc;
  border-radius: 4px 4px 0 0;
  ${(props) =>
    (props.theme === 'dark' || props.theme.theme === 'dark') &&
    css`
      background: #333;
      border-bottom-color: #666;
    `}
`;

export const CloseButton = styled.button`
  cursor: pointer;
  width: 60px;
  height: 60px;
  background: #33333330 url('/images/cross_icon_white.png') no-repeat center;
  border: 0;
  border-radius: 0 4px 0 0;
  position: absolute;
  right: 0px;
  top: 0px;
  transition: 0.2s all ease-in;
  &:hover {
    background-color: #333333ff;
  }
`;

export const Buttons = styled.div`
  padding: ${(props) => props.$pad}px;
  background: #f9f9f9;
  box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  border-top: 1px solid #ccc;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 0 0 4px 4px;
  & > button {
    margin: 0;
    height: ${(props) => props.$pad * 2}px;
    line-height: 1;
    min-width: ${(props) => props.$pad * 8}px;
  }
  ${(props) =>
    props.$align === 'left' &&
    css`
      justify-content: flex-start;
      & > button {
        margin: 0 ${(props) => props.$pad}px 0 0;
      }
    `}
  ${(props) =>
    props.$align === 'right' &&
    css`
      justify-content: flex-end;
      & > button {
        margin: 0 0 0 ${(props) => props.$pad}px;
      }
    `}
  ${(props) =>
    props.$pl &&
    css`
      padding-left: ${(props) => props.$pl};
    `}

  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      border-top-color: #444;
      background: #222;
    `}
`;
